'use client'

import Image from 'next/image'
import { useLanguage } from '@/contexts/LanguageContext'
import { useRouter } from 'next/navigation'
import ZigzagIcon from '@/assets/icons/ZigzagIcon'
import Link from 'next/link'
import { useTranslations } from 'next-intl'



export default function CategoriesStore({
  Categories = [],
  activeType,
}: {
  activeType?: string | any | null
  Categories: any[]
}) {
const { language } = useLanguage()
  const isRTL = language === 'ar'
  const router = useRouter()
  const t = useTranslations('store')
  return (
    <div className='  w-full max-w-[1440px] flex flex-col mx-auto ps-4   gap-3 md:gap-5'>
      <h2 className='text-[#D1D3D4] text-[30px] md:text-[40px] font-bold'>{t('browseAllCategories')}</h2>

         <div
        dir={isRTL ? 'rtl' : 'ltr'}
        className='scrollbar-hide flex w-full snap-x snap-mandatory gap-2 overflow-x-auto overflow-y-hidden overscroll-x-contain pb-1 sm:gap-2.5 md:gap-3'
      >
        {Categories.map((el, index) => {
          const isActive = Number(activeType) === Number(el.id)

          return (
            <Link
              href={el.has_sub_categories === 1 ? `/store/store-categories?type_id=${el.id}` : `/store/products-by-category/${el.id}`}
              key={el.id ?? index}
              className='w-[28%] shrink-0 snap-start cursor-pointer [scroll-snap-stop:always] min-[380px]:w-[19%] sm:w-[18%] md:w-[16%] lg:w-[11.25%]'
          
            >
              <div
                className={`
          flex flex-col items-center justify-center p-2 md:p-3 gap-2 md:gap-3 min-h-[85px] md:min-h-[134px] rounded-lg border transition
          ${isActive ? 'border-2 border-[#d9ac4f] z-100 bg-[#d9ac4f]/5 ' : 'border-[#d9ac4f]'}
        `}
              >
                <div className='relative w-10 h-10 md:w-[70px] md:h-[70px]'>
                  <Image
                    src={el.image}
                    alt={el.title}
                    fill
                    className='object-cover rounded-sm'
                  />
                </div>
                <p className='text-[#D1D3D4] text-[12px] md:text-[18px] text-center font-medium truncate'>
                  {el.title}
                </p>
              </div>
               </Link>
          )
        })}
      </div>

      <ZigzagIcon
        className='w- hidden md:block mt-5'
        color='#d9ac4f'
      />

      <ZigzagIcon
        className='w-full block md:hidden'
        color='#d9ac4f'
      />
    </div>
  )
}